<template>
    <SrMenu v-model="showMenu" offset-y attach>
        <template #activator="{}">
            <SrLabel :text="value" color="blue" class="mt-1 mr-2 mb-1" action-icon="expand-more" @action="showMenu = true" />
        </template>
        <SrList dense>
            <template v-for="operator in unusedOperators">
                <SrListItem :key="operator" @click="emitInput(operator)">
                    <SrListItemTitle>
                        {{ operator }}
                    </SrListItemTitle>
                </SrListItem>
            </template>
        </SrList>
    </SrMenu>
</template>

<script>
import PropagateInputEvent from '../../mixins/PropagateInputEvent';
import SrLabel from '../SrLabel/SrLabel';
import SrMenu from '../SrMenu/SrMenu';
import SrList from '../SrList/SrList';
import SrListItem from '../SrListItem/SrListItem';
import SrListItemTitle from '../SrListItemTitle/SrListItemTitle';
import { Operands } from './types';

export default {
    components: { SrLabel, SrMenu, SrList, SrListItem, SrListItemTitle },
    mixins: [PropagateInputEvent],
    props: {
        /**
         * @model operator
         */
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showMenu: false,
        };
    },
    computed: {
        unusedOperators() {
            return Object.values(Operands).filter((operator) => operator !== this.value);
        },
    },
};
</script>
